export default __webpack_public_path__ + "static/media/download-solid.b8a97b08.svg";